module.exports = __webpack_public_path__ + "media/Phoenix the Immortal soul.4851c4ae.mp3";